{
    "query-comment-columns": [
        {
            "display": "true",
            "ui_columnname": "Comment",
            "db_columnname": "comment",
            "datatype": "String",
            "mappingkey": "comment",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
         {
            "display": "true",
            "ui_columnname": "Sample Name",
            "db_columnname": "sampleName",
            "datatype": "String",
            "mappingkey": "sampleName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
         {
            "display": "true",
            "ui_columnname": "ReportDate",
            "db_columnname": "reportDate",
            "datatype": "String",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OrderID",
            "db_columnname": "orderID",
            "datatype": "String",
            "mappingkey": "orderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Symbol",
            "db_columnname": "symbol",
            "datatype": "String",
            "mappingkey": "symbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "FirmROEID",
            "db_columnname": "firmROEID",
            "datatype": "String",
            "mappingkey": "firmROEID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Updated User",
            "db_columnname": "updatedBy",
            "datatype": "String",
            "mappingkey": "updatedBy",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Updated Date",
            "db_columnname": "updateDate",
            "datatype": "String",
            "mappingkey": "updateDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        }
    ],
    "Quick-Search-Filter": [
        {
            "label": "Group Name",
            "columnname": "groupName",
            "placeholder": "Group Name",
            "width": "",
            "datatype": "String",
            "isLarge": true,
            "values": ""
        },
        {
            "label": "Type",
            "columnname": "Type",
            "placeholder": "Type",
            "width": "",
            "datatype": "Array",
            "isLarge": true,
            "values": ""
        },
        {
            "label": "Symbol",
            "columnname": "symbol",
            "placeholder": "Symbol",
            "width": "",
            "datatype": "String",
            "isLarge": true,
            "values": ""
        },
        {
            "label": "OrderID",
            "columnname": "orderID",
            "placeholder": "OrderID",
            "width": "",
            "datatype": "String",
            "isLarge": true,
            "values": ""
        },
         {
            "label": "Sample Name",
            "columnname": "sampleName",
            "placeholder": "Sample Name",
            "width": "",
            "datatype": "String",
            "isLarge": true,
            "values": ""
        }
    ],
    "GridColumns": [
        {
            "display": "true",
            "ui_columnname": "Action",
            "db_columnname": "Status",
            "datatype": "char",
            "mappingkey": "Status",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
         {
            "display": "true",
            "ui_columnname": "Source",
            "db_columnname": "Source",
            "datatype": "String",
            "mappingkey": "source",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Sample Name",
            "db_columnname": "sampleName",
            "datatype": "String",
            "mappingkey": "sampleName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ReportDate",
            "db_columnname": "reportDate",
            "datatype": "String",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "GroupName",
            "db_columnname": "groupName",
            "datatype": "String",
            "mappingkey": "groupName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Type",
            "db_columnname": "type",
            "datatype": "String",
            "mappingkey": "type",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Symbol",
            "db_columnname": "symbol",
            "datatype": "String",
            "mappingkey": "symbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OrderID",
            "db_columnname": "orderID",
            "datatype": "String",
            "mappingkey": "orderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OrderKeyDate",
            "db_columnname": "orderKeyDate",
            "datatype": "String",
            "mappingkey": "orderKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Event Timestamp",
            "db_columnname": "eventTimestamp",
            "datatype": "String",
            "mappingkey": "eventTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Firm ROEID",
            "db_columnname": "firmROEID",
            "datatype": "String",
            "mappingkey": "firmROEID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AccountHolderType",
            "db_columnname": "accountHolderType",
            "datatype": "String",
            "mappingkey": "accountHolderType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ActionType",
            "db_columnname": "actionType",
            "datatype": "String",
            "mappingkey": "actionType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AffiliateFlag",
            "db_columnname": "affiliateFlag",
            "datatype": "Boolean",
            "mappingkey": "affiliateFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AggregatedOrders",
            "db_columnname": "aggregatedOrders",
            "datatype": "String",
            "mappingkey": "aggregatedOrders",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AtsDisplayInd",
            "db_columnname": "atsDisplayInd",
            "datatype": "String",
            "mappingkey": "atsDisplayInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "AtsOrderType",
            "db_columnname": "atsOrderType",
            "datatype": "String",
            "mappingkey": "atsOrderType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "BFMMFlag",
            "db_columnname": "BFMMFlag",
            "datatype": "Boolean",
            "mappingkey": "BFMMFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CancelQty",
            "db_columnname": "cancelQty",
            "datatype": "int",
            "mappingkey": "cancelQty",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CATReporterIMID",
            "db_columnname": "CATReporterIMID",
            "datatype": "String",
            "mappingkey": "CATReporterIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CustDspIntrFlag",
            "db_columnname": "custDspIntrFlag",
            "datatype": "Boolean",
            "mappingkey": "custDspIntrFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "DeptType",
            "db_columnname": "deptType",
            "datatype": "String",
            "mappingkey": "deptType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Destination",
            "db_columnname": "destination",
            "datatype": "String",
            "mappingkey": "destination",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "DestinationType",
            "db_columnname": "destinationType",
            "datatype": "String",
            "mappingkey": "destinationType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "DisplayPrice",
            "db_columnname": "displayPrice",
            "datatype": "int",
            "mappingkey": "displayPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "DisplayQty",
            "db_columnname": "displayQty",
            "datatype": "Boolean",
            "mappingkey": "displayQty",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "DupROIDCond",
            "db_columnname": "dupROIDCond",
            "datatype": "String",
            "mappingkey": "dupROIDCond",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ElectronicDupFlag",
            "db_columnname": "electronicDupFlag",
            "datatype": "Boolean",
            "mappingkey": "electronicDupFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ElectronicTimestamp",
            "db_columnname": "electronicTimestamp",
            "datatype": "String",
            "mappingkey": "electronicTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ErrorROEID",
            "db_columnname": "errorROEID",
            "datatype": "String",
            "mappingkey": "errorROEID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "FirmDesignatedID",
            "db_columnname": "firmDesignatedID",
            "datatype": "String",
            "mappingkey": "firmDesignatedID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "HandlingInstructions",
            "db_columnname": "handlingInstructions",
            "datatype": "String",
            "mappingkey": "handlingInstructions",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "InfoBarrierID",
            "db_columnname": "infoBarrierID",
            "datatype": "String",
            "mappingkey": "infoBarrierID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "IsoInd",
            "db_columnname": "isoInd",
            "datatype": "String",
            "mappingkey": "isoInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ManualFlag",
            "db_columnname": "manualFlag",
            "datatype": "Boolean",
            "mappingkey": "manualFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ManualOrderID",
            "db_columnname": "manualOrderID",
            "datatype": "String",
            "mappingkey": "manualOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ManualOrderKeyDate",
            "db_columnname": "manualOrderKeyDate",
            "datatype": "Boolean",
            "mappingkey": "manualOrderKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "MinQty",
            "db_columnname": "minQty",
            "datatype": "int",
            "mappingkey": "minQty",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "MultiLegInd",
            "db_columnname": "multiLegInd",
            "datatype": "String",
            "mappingkey": "multiLegInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "NbboSource",
            "db_columnname": "nbboSource",
            "datatype": "String",
            "mappingkey": "nbboSource",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "NbboTimestamp",
            "db_columnname": "nbboTimestamp",
            "datatype": "String",
            "mappingkey": "nbboTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "NbbPrice",
            "db_columnname": "nbbPrice",
            "datatype": "int",
            "mappingkey": "nbbPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "NbbQty",
            "db_columnname": "nbbQty",
            "datatype": "int",
            "mappingkey": "nbbQty",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "NboPrice",
            "db_columnname": "nboPrice",
            "datatype": "Boolean",
            "mappingkey": "nboPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "NboQty",
            "db_columnname": "nboQty",
            "datatype": "int",
            "mappingkey": "nboQty",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "NegotiatedTradeFlag",
            "db_columnname": "negotiatedTradeFlag",
            "datatype": "Boolean",
            "mappingkey": "negotiatedTradeFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "NetPrice",
            "db_columnname": "netPrice",
            "datatype": "int",
            "mappingkey": "netPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OrderType",
            "db_columnname": "orderType",
            "datatype": "String",
            "mappingkey": "orderType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "OriginatingIMID",
            "db_columnname": "originatingIMID",
            "datatype": "String",
            "mappingkey": "originatingIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "PairedOrderID",
            "db_columnname": "pairedOrderID",
            "datatype": "String",
            "mappingkey": "pairedOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Price",
            "db_columnname": "price",
            "datatype": "int",
            "mappingkey": "price",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "PriorRoutedOrderID",
            "db_columnname": "priorRoutedOrderID",
            "datatype": "String",
            "mappingkey": "priorRoutedOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Quantity",
            "db_columnname": "quantity",
            "datatype": "int",
            "mappingkey": "quantity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "QuoteID",
            "db_columnname": "quoteID",
            "datatype": "String",
            "mappingkey": "quoteID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "QuoteKeyDate",
            "db_columnname": "quoteKeyDate",
            "datatype": "String",
            "mappingkey": "quoteKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "RepresentativeInd",
            "db_columnname": "representativeInd",
            "datatype": "String",
            "mappingkey": "representativeInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "RFQID",
            "db_columnname": "RFQID",
            "datatype": "String",
            "mappingkey": "RFQID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "RoutedOrderID",
            "db_columnname": "routedOrderID",
            "datatype": "String",
            "mappingkey": "routedOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "RouteRejectedFlag",
            "db_columnname": "routeRejectedFlag",
            "datatype": "Boolean",
            "mappingkey": "routeRejectedFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "SenderIMID",
            "db_columnname": "senderIMID",
            "datatype": "String",
            "mappingkey": "senderIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "SeqNum",
            "db_columnname": "seqNum",
            "datatype": "String",
            "mappingkey": "seqNum",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Session",
            "db_columnname": "session",
            "datatype": "String",
            "mappingkey": "session",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Side",
            "db_columnname": "side",
            "datatype": "String",
            "mappingkey": "side",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "SolicitationFlag",
            "db_columnname": "solicitationFlag",
            "datatype": "Boolean",
            "mappingkey": "solicitationFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TimeInForce",
            "db_columnname": "timeInForce",
            "datatype": "String",
            "mappingkey": "timeInForce",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "TradingSession",
            "db_columnname": "tradingSession",
            "datatype": "String",
            "mappingkey": "tradingSession",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "WorkingPrice",
            "db_columnname": "workingPrice",
            "datatype": "Boolean",
            "mappingkey": "workingPrice",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Comment",
            "db_columnname": "commentDetails",
            "datatype": "String",
            "mappingkey": "commentDetails",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Create Date",
            "db_columnname": "createDate",
            "datatype": "String",
            "mappingkey": "createDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Update Date",
            "db_columnname": "updateDate",
            "datatype": "String",
            "mappingkey": "updateDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "User",
            "db_columnname": "updatedBy",
            "datatype": "String",
            "mappingkey": "updatedBy",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        }
    ]
}